import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Application error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          color: 'var(--text-secondary, #4b5563)',
          padding: '20px',
          textAlign: 'center',
        }}>
          <p style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-primary, #111827)' }}>
            Something went wrong
          </p>
          <p style={{ fontSize: '14px', marginTop: '8px' }}>
            An unexpected error occurred. Please try{' '}
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); window.location.reload(); }}
              style={{ color: '#3b82f6' }}
            >
              refreshing the page
            </a>.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
